import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { ref, watch } from 'vue'
import { HOST_URL_IMGS } from '@/utils/constantes';
import { ITestimonial } from '@/interfaces/testimonials.interface';


export default /*@__PURE__*/_defineComponent({
  __name: 'TestimonialForm',
  props: {
    modelValue: {},
    isEdit: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:modelValue", "submit", "submit2", "cancel"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const form = ref<ITestimonial>({ ...props.modelValue })
const imageFile = ref<File | null>(null)
const imagePreview = ref<string | null>(null)
const formRef = ref() 
let previousUrl: string | null = null

watch(() => props.modelValue, (newVal) => {
  form.value = { ...newVal }
  imagePreview.value = getImagePath(newVal.image) //newVal.image?.startsWith('http') ? newVal.image : null
})
function getImagePath(path: string) {
    const baseURL = `${HOST_URL_IMGS}/public/imgs/output`
    return path.startsWith('http') ? path : baseURL +'/'+ path
}

watch(imageFile, (newVal) => {
  if (!newVal) {
    // Si el usuario borra la imagen (con la x)
    imagePreview.value = getImagePath(form.value.image)
    previousUrl = null
  }
})
function handleImagePreview() {
  if (imageFile.value instanceof Blob) {
    // Si hay archivo nuevo seleccionado
    if (previousUrl) {
      URL.revokeObjectURL(previousUrl)
    }
    const url = URL.createObjectURL(imageFile.value)
    imagePreview.value = url
    previousUrl = url
  } else {
    // Si el archivo se eliminó, restablecer imagen original
    imagePreview.value = getImagePath(form.value.image)
    previousUrl = null
  }
}

function onSubmit() { 
  form.value.updated_at = new Date().toISOString()
  if (!props.isEdit) {
    form.value.created_at = form.value.updated_at
  }
  emit('submit', { data: form.value, imageFile: imageFile.value })
}

function onSubmit2() {
  form.value.updated_at = new Date().toISOString()
  if (!props.isEdit) {
    form.value.created_at = form.value.updated_at
  }
  emit('submit2', { data: form.value, imageFile: imageFile.value })
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_rating = _resolveComponent("v-rating")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    onSubmit: _withModifiers(onSubmit, ["prevent"]),
    ref_key: "formRef",
    ref: formRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.couple,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.couple) = $event)),
                    variant: "outlined",
                    label: "Pareja",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.verse,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.verse) = $event)),
                    label: "versículo",
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: form.value.verse_references,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.verse_references) = $event)),
                    label: "Referencia de versículo",
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_date_input, {
                    modelValue: form.value.date,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.date) = $event)),
                    label: "Fecha",
                    "prepend-icon": "",
                    variant: "outlined",
                    "max-width": "368",
                    "persistent-placeholder": ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "4",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: form.value.type,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.type) = $event)),
                    label: "Tipo",
                    items: ['CRIS', 'HOME'],
                    "item-title": "Tipo*",
                    "item-value": "type",
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select, {
                    modelValue: form.value.status,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.status) = $event)),
                    label: "Estado",
                    items: ['A', 'I'],
                    "item-title": "status",
                    "item-value": "status",
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "9",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_file_input, {
                    label: "Imagen",
                    accept: "image/*",
                    modelValue: imageFile.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((imageFile).value = $event)),
                    onChange: handleImagePreview,
                    "prepend-icon": "",
                    "show-size": "",
                    chips: "",
                    hint: imageFile.value ? imageFile.value.name : form.value.image,
                    "persistent-hint": "",
                    variant: "outlined"
                  }, null, 8, ["modelValue", "hint"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "3"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_rating, {
                    "half-increments": "",
                    hover: "",
                    length: 5,
                    size: 22,
                    modelValue: form.value.rating,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.rating) = $event)),
                    "active-color": "primary"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    src: imagePreview.value || getImagePath(form.value.image) || '',
                    "max-height": "300",
                    class: "my-2 rounded",
                    cover: ""
                  }, null, 8, ["src"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "12",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: form.value.quote,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.quote) = $event)),
                    label: "Cita",
                    rows: "2",
                    variant: "outlined"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _cache[10] || (_cache[10] = _createElementVNode("small", { class: "text-caption text-medium-emphasis" }, "*indicates required field", -1))
        ]),
        _: 1,
        __: [10]
      }),
      _createVNode(_component_v_divider),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          (!_ctx.isEdit)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                color: "primary",
                text: "Guardar",
                variant: "tonal",
                loading: props.loading,
                onClick: onSubmit2
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true),
          (_ctx.isEdit)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 1,
                color: "primary",
                text: "editar",
                variant: "tonal",
                type: "submit",
                loading: props.loading
              }, null, 8, ["loading"]))
            : _createCommentVNode("", true),
          _createVNode(_component_v_btn, {
            text: "Cancelar",
            variant: "plain",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('cancel')))
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})